import type { User } from "../types";

export function UserAvatar({ className = "avatar", user }: Readonly<{
  className?: string;
  user: Pick<User, "avatarColor" | "avatarUrl" | "displayName">;
}>) {
  return (
    <span className={className} style={{ background: user.avatarColor }}>
      {user.avatarUrl
        ? <img alt="" decoding="async" loading="lazy" src={user.avatarUrl} />
        : user.displayName.slice(0, 1).toUpperCase()}
    </span>
  );
}
